import Vue from 'vue'

import Home from './Home'
import Products from './Products'
import Colour from './Colour'
import UseCase from './UseCase'
import Solution from './Solution'
import Profile from './Profile'
import CadLibrary from './CadLibrary'
import Contact from './Contact'
import SignUp from './SignUp'
import NewSupplier from './NewSupplier'
import Moodboard from './Moodboard'
import ViewMoodboard from './ViewMoodboard'
import Articles from './Articles'
import InspirationGallery from './InspirationGallery'
import CaseStudies from './CaseStudies'
import CaseStudy from './CaseStudy'
import Downloads from './Downloads'
import Page from './Page'
import Supplier from './Supplier'
import Sample from './Sample'
import StaticSample from './StaticSample'
import VisualiserLanding from './VisualiserLanding'
import Visualiser from './Visualiser'
import Search from './Search'
import Landing from './Landing'
import Magazine from './Magazine'

Vue.component('v-home', Home)
Vue.component('v-landing', Landing)
Vue.component('v-products', Products)
Vue.component('v-cadlibrary', CadLibrary)
Vue.component('v-colour', Colour)
Vue.component('v-use-case', UseCase)
Vue.component('v-profile', Profile)
Vue.component('v-solution', Solution)
Vue.component('v-contact', Contact)
Vue.component('v-sign-up', SignUp)
Vue.component('v-new-supplier', NewSupplier)
Vue.component('v-viewmoodboard', ViewMoodboard)
Vue.component('v-moodboard', Moodboard)
Vue.component('v-articles', Articles)
Vue.component('v-inspiration-gallery', InspirationGallery)
Vue.component('v-case-studies', CaseStudies)
Vue.component('v-case-study', CaseStudy)
Vue.component('v-downloads', Downloads)
Vue.component('v-page', Page)
Vue.component('v-supplier', Supplier)
Vue.component('v-sample', Sample)
Vue.component('v-static-sample', StaticSample)
Vue.component('v-visualiser-landing', VisualiserLanding)
Vue.component('v-visualiser', Visualiser)
Vue.component('v-search', Search)
Vue.component('v-magazine', Magazine)





